import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminApi, setAdminToken } from "../lib/adminApi";
import { Loader2, Shield } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const r = await adminApi.login(username.trim(), password);
      setAdminToken(r.token);
      navigate("/admin");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center bg-[#0F172A] text-slate-100 font-mono px-6"
    >
      <form
        onSubmit={submit}
        className="w-full max-w-sm bg-[#1E293B] border border-slate-700 rounded-xl p-7 shadow-2xl"
      >
        <div className="flex items-center gap-2 mb-6 text-emerald-400">
          <Shield className="w-5 h-5" />
          <span className="text-xs uppercase tracking-[0.22em] font-semibold">
            TherapyNote · Admin
          </span>
        </div>

        <h1 className="text-xl font-semibold tracking-tight mb-1">Owner sign-in</h1>
        <p className="text-xs text-slate-400 mb-6">
          Only the owner account can access this panel.
        </p>

        <label className="block text-[11px] uppercase tracking-wider text-slate-400 mb-1">
          Username
        </label>
        <input
          data-testid="admin-login-username"
          autoFocus
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="w-full bg-[#0F172A] border border-slate-700 rounded-md px-3 py-2 text-sm mb-4 focus:outline-none focus:border-emerald-500"
        />

        <label className="block text-[11px] uppercase tracking-wider text-slate-400 mb-1">
          Password
        </label>
        <input
          data-testid="admin-login-password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full bg-[#0F172A] border border-slate-700 rounded-md px-3 py-2 text-sm mb-5 focus:outline-none focus:border-emerald-500"
        />

        {error && (
          <div
            data-testid="admin-login-error"
            className="mb-4 text-xs text-red-400 border border-red-900/60 bg-red-950/40 rounded-md px-3 py-2"
          >
            {error}
          </div>
        )}

        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={busy || !username || !password}
          className="w-full bg-emerald-600 hover:bg-emerald-500 disabled:opacity-50 text-white text-sm font-medium rounded-md py-2.5 inline-flex items-center justify-center gap-2 transition-colors"
        >
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign in"}
        </button>
      </form>
    </div>
  );
}
